import Vue from 'vue'
import Vuex from 'vuex'
import main from './main'
import stats from './stats'
import cp from './cp'
import development from './development'
import reports from './reports'
import scoreboard from './scoreboard'
import overview from './overview'
import meetings from './meetings'
import naestved from './naestved'
import training from './training'
import quality from './quality'
import distribution from './distribution'

Vue.use(Vuex)

export default new Vuex.Store({
    modules: {
        main,
        stats,
        cp,
        development,
        reports,
        scoreboard,
        overview,
        meetings,
        naestved,
        training,
        quality,
        distribution
    }
})